import React, { useEffect } from 'react';
import { Controller, Control } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { StoreBasicDataApiStructure } from 'common/types';
import { CheckoutType } from 'api/repositories/Checkout';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from 'common/components/Radio';
import { SHIPPING_FORM } from '../../../common/constants';
import ErrorPanel from 'common/components/ErrorPanel';
import { CheckoutValues } from 'store/ducks/checkout/types';
import { RadioLoader } from '../../../common/loaders';
import logoGLS from 'assets/images/gls_logo.jpg';
import { makeStyles } from '@material-ui/core/styles';
import { Hidden } from '@material-ui/core';

type Props = {
    cartToken: string;
    checkoutData: StoreBasicDataApiStructure<CheckoutType>;
    checkoutValues: CheckoutValues;
    control: Control;
    fetchCheckoutData: Function;
    errors: any;
};

const makeLogoStyles = makeStyles({
    logo: {
        height: '1rem',
        marginLeft: '0.75rem',
        width: 'auto',
    },
});

const ShippingForm: React.FC<Props> = ({
    cartToken,
    checkoutData,
    checkoutValues,
    control,
    fetchCheckoutData,
    errors,
}) => {
    const { logo } = makeLogoStyles();

    const { isLoading } = checkoutData;
    const shippingMethods = Object.values(checkoutData.data?.shipments?.[0].methods || {}) || [];

    useEffect(() => {
        fetchCheckoutData(`checkout/${cartToken}/shipping`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Grid container>
            <Grid item xs={12}>
                {isLoading ? (
                    <RadioLoader />
                ) : (
                    <Controller
                        as={RadioGroup}
                        control={control}
                        name={SHIPPING_FORM}
                        defaultValue={checkoutValues.shippingForm || ''}
                    >
                        {shippingMethods.map(({ code, description }) => {
                            const Description = () => (
                                <Box alignItems="center" display="flex">
                                    {description}
                                    <Hidden xsDown>
                                        {code === 'gls' && (
                                            <>
                                                <img alt="GLS" className={logo} src={logoGLS} />
                                                <Box fontWeight={600} marginLeft={1.5}>
                                                    0 zł
                                                </Box>
                                            </>
                                        )}
                                    </Hidden>
                                </Box>
                            );

                            return (
                                <FormControlLabel
                                    key={code}
                                    control={<Radio />}
                                    label={<Description />}
                                    value={code}
                                />
                            );
                        })}
                    </Controller>
                )}
                <ErrorPanel errors={errors} name={SHIPPING_FORM} />
            </Grid>
        </Grid>
    );
};

export default ShippingForm;
